// User profile persistence (age, sex).

const KEY = "sentinel.userProfile";

export function loadProfile() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || typeof p !== "object") return null;
    return p;
  } catch (e) {
    return null;
  }
}

export function saveProfile(profile) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(profile));
  } catch (e) {
    // ignore
  }
}

export function clearProfile() {
  try {
    window.localStorage.removeItem(KEY);
  } catch (e) {
    // ignore
  }
}
